// Blog custom colors interface
export interface BlogCustomColors {
  pageBackground?: string;
  sidebarBackground?: string;
  cardBackground?: string;
  headingColor?: string;
  textColor?: string;
  mutedTextColor?: string;
  postTitleColor?: string;
  postTextColor?: string;
  postMetaColor?: string;
  linkColor?: string;
  linkHoverColor?: string;
  primaryColor?: string;
  tagBackground?: string;
  tagText?: string;
  borderColor?: string;
  cardBorderColor?: string;
}

// Color customization categories for UI organization
export const colorCategories = [
  {
    name: 'Backgrounds',
    colors: [
      { key: 'pageBackground', label: 'Page Background' },
      { key: 'sidebarBackground', label: 'Sidebar Background' },
      { key: 'cardBackground', label: 'Card Background' },
    ],
  },
  {
    name: 'Text',
    colors: [
      { key: 'headingColor', label: 'Headings' },
      { key: 'textColor', label: 'Body Text' },
      { key: 'mutedTextColor', label: 'Muted Text' },
    ],
  },
  {
    name: 'Posts',
    colors: [
      { key: 'postTitleColor', label: 'Post Title' },
      { key: 'postTextColor', label: 'Post Content' },
      { key: 'postMetaColor', label: 'Post Meta' },
    ],
  },
  {
    name: 'Links & Accents',
    colors: [
      { key: 'linkColor', label: 'Link Color' },
      { key: 'linkHoverColor', label: 'Link Hover' },
      { key: 'primaryColor', label: 'Primary/Accent' },
    ],
  },
  {
    name: 'Tags',
    colors: [
      { key: 'tagBackground', label: 'Tag Background' },
      { key: 'tagText', label: 'Tag Text' },
    ],
  },
  {
    name: 'Borders',
    colors: [
      { key: 'borderColor', label: 'Border Color' },
      { key: 'cardBorderColor', label: 'Card Border' },
    ],
  },
];

export interface BlogSettingsForm {
  title: string;
  description: string;
  basePath: string;
  layout: 'grid' | 'list' | 'magazine';
  layoutId: string | null;
  showLayout: boolean;
  postsPerPage: number;
  showAuthor: boolean;
  showDate: boolean;
  showReadingTime: boolean;
  showFeaturedImage: boolean;
  showTags: boolean;
}
